var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xunlinEchartPage"},[_c('p',{staticClass:"dw"},[_vm._v("次")]),_c('ve-line',{attrs:{"data":_vm.chartData,"init-options":_vm.initOptions,"settings":_vm.chartSettings,"extend":_vm.chartExtend,"height":_vm.lineHeight}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }